import { Controller } from "stimulus";
import Rails from "rails-ujs";

export default class extends Controller {

  static targets = ["total", "giftSelectionText", "toggleGiftSelectionBtn", "confirmGiftSelectionBtn", "giftNoteModal", "giftNoteTextarea", "saveNoteBtn", "freeProductsNotice", "sendOrderBtn"];

  connect() {
    // this.updateTotal();
    window.selectedGifts = [];

    // document.body.addEventListener("click", function(e) {

    //   if (e.target.closest("#mobileCartMenu")) {
    //     var mobileMenu = document.getElementById("#mobileCartMenu")
    //     if (!!mobileMenu) {
    //       mobileMenu.classList.add("-translate-x-full");

    //     }
    //   }
    // });

  }

  deselectAllProducts(e) {
    e.preventDefault();
    e.stopPropagation();
    document.querySelectorAll("#cart_products .product input[type=checkbox]:not([disabled])").forEach((p) => {


      // this.saveSelection(p.dataset.productId, p.dataset.customProductId, false);
      p.checked = false;



      // if (p.checked == true) {
      //   p.click();
      // }
    });


    this.saveMassSelection();

    // document.querySelectorAll(".basket input[type=checkbox]").forEach((p) => {
    //   p.checked = false;
    //   this.saveSelection(p.dataset.productId, p.dataset.customProductId, false);
    //   // if (p.checked == true) {
    //   //   p.click()
    //   // }
    // });

    document.getElementById("mobileCartMenu").classList.add("-translate-x-full");
  }

  selectFirstTenProducts(e) {
    e.preventDefault();
    e.stopPropagation();
    // this.deselectAllProducts(e);
    var products = [...document.querySelectorAll("#cart_products .product:not(.discount) input[type=checkbox]:not([disabled])")];
    // var baskets = [...document.querySelectorAll(".basket input[type=checkbox]")];

    products.slice(0, 10).forEach((p) => {
      // p.checked = true;

      // p.click();


      // this.saveSelection(p.dataset.productId, p.dataset.customProductId, true);
      p.checked = true;


    });

    this.saveMassSelection();

    // if (products.length < 10 && baskets.length > 0) {
    //   var diff = 10 - products.length;

    //   baskets.slice(0, diff).forEach((p) => {

    //     // default: send with order

    //     // p.checked = true;

    //       // p.click();

    //       // p.checked = true;

    //       // this.saveSelection(p.dataset.productId, p.dataset.customProductId, true);

    //   });

    // }
    document.getElementById("mobileCartMenu").classList.add("-translate-x-full");
  }


  saveMassSelection() {
    var checkedProducts = [...document.querySelectorAll("#cart_products .product input[type=checkbox]:not([disabled]):checked")];

    var productsIds = checkedProducts.map((p) => {
      if (p.dataset.customProductId == undefined) {
        return p.dataset.productId;
      }
    }).filter((x) => x !== undefined)


    var customProductsIds = checkedProducts.map((p) => {
      return p.dataset.customProductId;

    }).filter((x) => x !== undefined)

    fetch("/shop/cart/save_mass_selection", {
      method: "post",
      credentials: "same-origin",
      headers: {
        'Accept': "application/json, text/plain, */*",
        "Content-Type": "application/json",
        "X-CSRF-Token": Rails.csrfToken(),
      },
      body: JSON.stringify({ products_ids: productsIds, custom_products_ids: customProductsIds }),
    }).then((response) => {

    });


  }


  saveSelection(productID, customProductID, isChecked) {

    console.log(`SAVE SELECTION: ${productID} - ${customProductID} - ${isChecked}`)

    fetch("/shop/cart/save_selection", {
      method: "post",
      credentials: "same-origin",
      headers: {
        'Accept': "application/json, text/plain, */*",
        "Content-Type": "application/json",
        "X-CSRF-Token": Rails.csrfToken(),
      },
      body: JSON.stringify({ product_id: productID, custom_product_id: customProductID, checked: isChecked }),
    }).then((response) => {

    });
  }


  updateTotalOnRemoveElement() {
    setTimeout(() => {
      this.updateTotal();
    }, 1200);
  }


  updateTotal() {


    console.log('update total')
    var total = 0;
    this.element.querySelectorAll('.product-cart-preview input[type="checkbox"]#selected_product:checked').forEach((p) => {
      var productID = p.dataset.productId;
      var customProductID = p.dataset.customProductId;

      var price = parseFloat(p.closest(".product-cart-preview").dataset.price);

      if (customProductID != undefined) {
        var qty = parseInt(document.querySelector(`#custom_product_${customProductID}_qty`).innerText);
      } else if (productID != undefined) {
        var qty = parseInt(document.querySelector(`#product_${productID}_qty`).innerText);
      }

      total += (price * qty);
    });


    var adventCalendarsTotal = 0;
    this.element.querySelectorAll('.product-cart-preview.custom_advent_calendar input[type="checkbox"]#selected_product:checked').forEach((p) => {
      var productID = p.dataset.productId;
      var customProductID = p.dataset.customProductId;
      var price = parseFloat(p.closest(".product-cart-preview").dataset.price);

      if (customProductID != undefined) {
        var qty = parseInt(document.querySelector(`#custom_product_${customProductID}_qty`).innerText);
      } else if (productID != undefined) {
        var qty = parseInt(document.querySelector(`#product_${productID}_qty`).innerText);
      }

      adventCalendarsTotal += (price * qty);
    });


    if (total > 0) {
      total += 5;

      if (this.hasSendOrderBtnTarget) {
        this.sendOrderBtnTarget.classList.remove("hidden")
      }
    } else {
      if (this.hasSendOrderBtnTarget) {
        this.sendOrderBtnTarget.classList.add("hidden")
      }
    }

    // Ceste regalo
    this.element.querySelectorAll('input[type="checkbox"]#selected_basket:checked').forEach((p) => {
      // var price = parseFloat(p.dataset.price); // 7€ aggiuntivi inclusi
      

      var containedProductsIds = p.closest("div.basket").dataset.containedProductsIds.split(",");
      
      

      var selectedProducts = this.element.querySelectorAll('.product-cart-preview input[type="checkbox"]#selected_product:checked');

      var selectedContainedProducts = [...selectedProducts].filter((x) => containedProductsIds.includes(x.dataset.productId));

      // console.log("SELECT1")
      // console.log(selectedContainedProducts);
      // console.log(containedProductsIds.length);
      // console.log(selectedContainedProducts.length == containedProductsIds.length);
      // console.log("SELECT2")

      if (selectedContainedProducts.length == containedProductsIds.length) {
        total += 7;
      }

    });



   

    var additionalCheckoutOptionsFees = parseFloat(this.element.dataset.additionalCheckoutOptionsFees);

    if (!!additionalCheckoutOptionsFees) {
      total += additionalCheckoutOptionsFees;
    }

    this.totalTarget.innerText = `${total.toFixed(2).toString().replace(".", ",")} €`

    var nearest100 = Math.ceil(total / 100) * 100
    var nearestGift = nearest100 - 1;
      

    var totalExcludingAdventCalendars = total - adventCalendarsTotal;

    if (this.hasFreeProductsNoticeTarget) {
      if (totalExcludingAdventCalendars > 67) {

        if (nearestGift - totalExcludingAdventCalendars <= 33) {
          var nearestGiftDiffInEuro = `${(nearestGift - totalExcludingAdventCalendars).toFixed(2).toString().replace(".", ",")} €`;
          this.freeProductsNoticeTarget.innerText = `Un omaggio ti attende, ti mancano solo ${nearestGiftDiffInEuro} per riceverlo!`

          this.freeProductsNoticeTarget.classList.remove("hidden");

          if (window.innerWidth < 768) {
            this.freeProductsNoticeTarget.classList.add("animate__animated", "animate__fadeOut", "animate__delay-5s")
          }


        } else {
          this.freeProductsNoticeTarget.classList.add("hidden");
        }

      } else {
        this.freeProductsNoticeTarget.classList.add("hidden");
      }
    }

    // TEMP - checked halloween advent calendar only
    var halloweenAdventCalendar = [...document.querySelectorAll('.custom_advent_calendar[data-parent-product="1381"]')].filter(x => !!x.querySelector('input[type="checkbox"]:checked'))[0];

    if (!!halloweenAdventCalendar == false) {
      var halloweenAdventcalendarDiscountCode = document.querySelector('.applied-discount-code[data-code="ZUCCA5"]');
      if (!!halloweenAdventcalendarDiscountCode) {
        halloweenAdventcalendarDiscountCode.classList.add("is-hidden");
        halloweenAdventcalendarDiscountCode.querySelector("button").click();
      }
    }

     // Discount codes
    if (total > 0) {
      this.element.querySelectorAll(".applied-discount-code").forEach((code) => {
        var percentage = code.dataset.percentage;
        var fixedAmount = code.dataset.fixedAmount;
        var discountCodeCode = code.dataset.code; 

        if (discountCodeCode == "ZUCCA5" && !!halloweenAdventCalendar == false) {
          return;
        }


        if (percentage.length > 0) {
          var percentValue = (discountCodeCode == "ZUCCA5" && !!halloweenAdventCalendar ? halloweenAdventCalendar.dataset.price : total) * (percentage/100)
          total = total - percentValue
        } else if (fixedAmount.length > 0) {
          total = total - fixedAmount;
        }


        this.totalTarget.innerText = `${total.toFixed(2).toString().replace(".", ",")} €`

      });
    }


  }

  toggleEditGiftSelection(e) {
    console.log("toggle edit event", e.target.parentElement.dataset.giftId);
    window.dispatchEvent(new CustomEvent("toggle-edit-gift-selection", { detail: { "giftID": e.target.parentElement.dataset.giftId } }))
  }

  toggleGiftSelection() {
    const event = new CustomEvent("toggle-gift-selection");
    window.dispatchEvent(event);
    this.giftSelectionTextTarget.classList.toggle("hidden");
    this.toggleGiftSelectionBtnTarget.classList.toggle("hidden");
    this.confirmGiftSelectionBtnTarget.classList.toggle("hidden");
  }

  confirmGiftSelection(e) {
    e.preventDefault();


    if (document.querySelectorAll("#confirm_gifts_selection input[type=hidden][data-gift=true]").length == 0) {
      this.saveNoteBtnTarget.click();
    } else {
      this.giftNoteModalTarget.classList.remove("hidden");
    }
  }

  confirmGiftNote() {
    this.giftNoteModalTarget.classList.add("hidden");
    var giftNote = this.giftNoteTextareaTarget.value;
    var selectedProductsIds = [...document.querySelectorAll("input.select-gift:checked")].map(x => x.value);
    this.giftNoteTextareaTarget.value = ""

    var giftId = Math.random().toString(36).slice(2, 7);
    window.selectedGifts.push({ id: giftId, products: selectedProductsIds, note: giftNote })
    console.log("saved gift selection", window.selectedGifts);

    this.toggleGiftSelection()

    window.dispatchEvent(new CustomEvent("update-selected-gift-badges"))

  }


}
